import { newThor } from './thor';
import { newVendor } from './vendor';
import { newDriverGuard } from './driver-guard';
/**
 * Class implements Connex interface
 */
export class Framework {
    /**
     * constructor
     * @param driver the driver instance
     */
    constructor(driver) {
        this.thor = newThor(driver);
        this.vendor = newVendor(driver);
    }
    /**
     * create a wrapper for driver, to validate responses. it should be helpful to make sure driver is properly
     * implemented in development stage.
     * @param driver the driver to be wrapped
     * @param errorHandler optional error handler. If omitted, error message will be printed via console.warn.
     */
    static guardDriver(driver, errorHandler) {
        return newDriverGuard(driver, errorHandler);
    }
}
export { newVendor };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLFFBQVEsQ0FBQTtBQUNoQyxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sVUFBVSxDQUFBO0FBQ3BDLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQTtBQUUvQzs7R0FFRztBQUNILE1BQU0sT0FBTyxTQUFTO0lBaUJsQjs7O09BR0c7SUFDSCxZQUFZLE1BQXFCO1FBQzdCLElBQUksQ0FBQyxJQUFJLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQzNCLElBQUksQ0FBQyxNQUFNLEdBQUcsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQ25DLENBQUM7SUF2QkQ7Ozs7O09BS0c7SUFDSSxNQUFNLENBQUMsV0FBVyxDQUNyQixNQUFxQixFQUNyQixZQUFtQztRQUVuQyxPQUFPLGNBQWMsQ0FBQyxNQUFNLEVBQUUsWUFBWSxDQUFDLENBQUE7SUFDL0MsQ0FBQztDQWFKO0FBRUQsT0FBTyxFQUFFLFNBQVMsRUFBRSxDQUFBIn0=